import auditApi from './api';

export default [auditApi()];
